module.exports = __webpack_public_path__ + "img/img7.dd763fb2.png";